import { Controller } from '@hotwired/stimulus';

// Formulaire d'import : après un import réel réussi, « Simulation » est
// recochée, pour qu'un second clic ne réimporte pas le même fichier.
export default class extends Controller {
    static targets = ['simulation'];

    done({ detail: { success } }) {
        if (success && !this.simulationTarget.checked) this.simulationTarget.checked = true;
    }
}
